(ns frontend.browser-utils
  (:require [clojure.string :as string]))

(defn userAgent
  []
  (-> js/navigator .-userAgent))

(defn low-user
  []
  (-> (userAgent)
      (str)
      (string/lower-case)))

(defn FF?
  []
  (string/includes? (low-user) "firefox"))

(defn websocket-url
  []
  ;; TODO : fix this to be https always when not in local DEV environment
  ;; To make it easier to test local environment, only force secure connection when the location is not IP address or localhost
  (-> js/window.location.protocol
      {"http:"  "ws:"
       "https:" "wss:"}
      (str "//" js/window.location.host "/ws")))
